import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=f3b5f92c&scoped=true"
var script = {}
import style0 from "./Faq.vue?vue&type=style&index=0&id=f3b5f92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b5f92c",
  null
  
)

export default component.exports